export const DISCONNECTED_SYNC_MIN_MS = 55 * 1000;
export const DISCONNECTED_SYNC_MAX_MS = 75 * 1000;
export const CONNECTED_RECONCILE_MIN_MS = 9 * 60 * 1000;
export const CONNECTED_RECONCILE_MAX_MS = 11 * 60 * 1000;

export const randomDelayBetween = (minMs, maxMs, randomValue = Math.random()) => {
  const min = Math.max(0, Number(minMs) || 0);
  const max = Math.max(min, Number(maxMs) || min);
  const ratio = Math.min(1, Math.max(0, Number(randomValue) || 0));
  return Math.round(min + ((max - min) * ratio));
};

export const nextDisconnectedSyncDelay = () =>
  randomDelayBetween(DISCONNECTED_SYNC_MIN_MS, DISCONNECTED_SYNC_MAX_MS);

export const nextConnectedReconcileDelay = () =>
  randomDelayBetween(CONNECTED_RECONCILE_MIN_MS, CONNECTED_RECONCILE_MAX_MS);
